import { OnInit, ElementRef, Renderer2 } from '@angular/core';
import { getContentClasses } from './helper/get-classes';
var TextComponent = /** @class */ (function () {
    function TextComponent(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.isShow = true;
    }
    Object.defineProperty(TextComponent.prototype, "contentClass", {
        set: function (Content) {
            if (!this.classToOverride) {
                if (getContentClasses(Content)) {
                    this.renderer.addClass(this.elementRef.nativeElement, "text-panel" + getContentClasses(Content));
                    if (getContentClasses(Content) === '--html') {
                        this.renderer.addClass(this.elementRef.nativeElement, 'rte');
                    }
                }
                else {
                    this.removeEmptyDiv();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextComponent.prototype, "innerHTMLClass", {
        set: function (Content) {
            if (!this.classToOverride && getContentClasses(Content)) {
                this.renderer.addClass(this.elementRef.nativeElement, "text-panel" + getContentClasses(Content));
                if (getContentClasses(Content) === '--html') {
                    this.renderer.addClass(this.elementRef.nativeElement, 'rte');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    TextComponent.prototype.removeEmptyDiv = function () {
        this.isShow = false;
    };
    TextComponent.prototype.ngOnInit = function () {
        var initialClassName = this.elementRef.nativeElement.className;
        if (this.classToOverride) {
            this.className = initialClassName + " text-panel--" + this.classToOverride;
        }
        else {
            this.className = initialClassName;
        }
    };
    return TextComponent;
}());
export { TextComponent };
